<template>
  <div class="data-container overflow-auto bg-white shadow rounded-lg">
    <div class="p-4">
      <!-- Table Header -->
      <div class="grid grid-cols-7 gap-4 font-bold py-2">
        <div class="col-span-1">
          ID# / Status
        </div>
        <div class="col-span-2">
          Request Name
        </div>
        <div class="col-span-3">
          Description
        </div>
        <div class="col-span-1">
          Hours
        </div>
      </div>

      <!-- Table Body -->
      <div class="divide-y divide-gray-200">
        <!-- Loop through Tickets -->
        <div
          v-for="ticket in tickets"
          :key="`ticket-${ticket.id}`"
          class="grid grid-cols-7 gap-4 py-2 break-inside-avoid"
        >
          <div class="col-span-1">
            {{ ticket.id }}<br>{{ ticket.standing }}
          </div>
          <div class="col-span-2">
            {{ ticket.title }}
          </div>
          <div class="col-span-3">
            {{ truncateDescription(ticket.description) }}
          </div>
          <div class="col-span-1">
            {{ convertToHours(ticket.billable_Seconds) }}
          </div>
        </div>

        <!-- Loop through Projects -->
        <div
          v-for="project in projects"
          :key="`project-${project.id}`"
          class="grid grid-cols-7 gap-4 py-2 bg-gray-50 break-inside-avoid"
        >
          <div class="col-span-1">
            {{ project.id }}<br>{{ project.standing }}
          </div>
          <div class="col-span-2">
            {{ project.title }}
          </div>
          <div class="col-span-3">
            {{ truncateDescription(project.description) }}
          </div>
          <div class="col-span-1">
            {{ convertToHours(project.billable_Seconds) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Notes area: editable normally, but swapped for div during PDF capture -->
    <div
      v-if="!isDownloading || (isDownloading && note.trim() !== '')"
      class="flex justify-center items-center mb-8 mt-4 notes-block"
    >
      <div class="bg-white shadow-lg rounded-lg w-4/5 p-4">
        <!-- PDF mode: show wrapped text in a div -->
        <div
          v-if="pdfMode"
          class="w-full p-2 border border-gray-300 rounded-lg whitespace-pre-wrap break-words text-gray-800"
        >
          {{ note }}
        </div>

        <!-- Normal/edit mode: show textarea -->
        <textarea
          v-else
          v-model="note"
          placeholder="Enter your notes here..."
          class="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent whitespace-pre-wrap break-words overflow-x-hidden"
          rows="4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useDsaReportsStore } from '../pinia/dsaReportsStore';
import { useDsaReportsTicketsStore } from '../pinia/dsaReportsTicketsStore';
import { useDsaReportsProjectsStore } from '../pinia/dsaReportsProjectsStore';
import { computed, ref } from 'vue';

export default {
  name: 'TicketInformation',

  props: {
    previewMode: { type: Boolean, default: false },
    pdfMode:     { type: Boolean, default: false }
  },

  setup() {
    const myStore      = useDsaReportsStore();
    const ticketStore  = useDsaReportsTicketsStore();
    const projectStore = useDsaReportsProjectsStore();

    const tickets   = computed(() => ticketStore.tickets);
    const projects  = computed(() => projectStore.projects);

    const note = computed({
      get: () => myStore.reportNotes,
      set: value => myStore.setNote(value)
    });

    const isDownloading = ref(false);

    return { tickets, projects, note, isDownloading };
  },

  methods: {
    convertToHours(seconds) {
      return (parseInt(seconds) / 3600).toFixed(2);
    },
    truncateDescription(description) {
      if (!description) return '';
      return description.length > 100
        ? description.substring(0, 100) + '...'
        : description;
    }
  }
};
</script>

<style scoped>
.break-inside-avoid {
  break-inside: avoid;
  page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
}

.notes-block {
  margin-top: 20px;
  break-inside: avoid;
  page-break-inside: avoid;
}
</style>
